'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHomes = exports.getHomeRouteProps = exports.getHome = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _reselect = require('reselect');

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _selectors = require('../Communities/selectors');

var _selectors2 = require('../Builder/selectors');

var _Filters = require('../Filters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParamsToPropsMap = {
  homeStreetAddress: 'address.streetAddress',
  homeCity: 'address.addressLocality',
  homeState: 'address.addressRegion',
  homeFullAddress: {
    path: 'address',
    resolve: function resolve(state, address) {
      return _fp2.default.get('streetAddress', address) + ' ' + _fp2.default.get('addressLocality', address) + ' ' + _fp2.default.get('addressRegion', address);
    }
  },
  communityName: {
    path: 'containedIn',
    resolve: function resolve(state, _id) {
      var community = (0, _selectors.getCommunity)(state, { _id: _id });
      return community ? community.name : undefined;
    }
  },
  communityMarketArea: {
    path: 'containedIn',
    resolve: function resolve(state, _id) {
      var community = (0, _selectors.getCommunity)(state, { _id: _id });
      return community ? community.area : undefined;
    }
  },
  communityMarketAreaMetro: {
    path: 'containedIn',
    resolve: function resolve(state, _id) {
      var areas = (0, _selectors2.getAreas)(state);
      var area = _fp2.default.find({ name: _fp2.default.get('area', (0, _selectors.getCommunity)(state, { _id: _id })) })(areas);

      if (area && !area.isMetro && area.parentMetro) {
        area = _fp2.default.find({ name: area.parentMetro })(areas);
      }

      return area ? area.name : undefined;
    }
  },
  communityMarketAreaSubMetro: {
    path: 'containedIn',
    resolve: function resolve(state, _id) {
      var areas = (0, _selectors2.getAreas)(state);
      var area = _fp2.default.find({ name: _fp2.default.get('area', (0, _selectors.getCommunity)(state, { _id: _id })) })(areas);

      return area ? area.name : undefined;
    }
  }
};

var getHome = function getHome(state, _ref) {
  var match = _ref.match,
      _id = _ref._id,
      _ref$builderId = _ref.builderId,
      builderId = _ref$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref$builderId;
  var _state$cloudData = state.cloudData;
  _state$cloudData = _state$cloudData === undefined ? {} : _state$cloudData;
  var homes = _state$cloudData.homes;
  var communityMarketArea = routeParamsToPropsMap.communityMarketArea,
      communityMarketAreaMetro = routeParamsToPropsMap.communityMarketAreaMetro,
      communityMarketAreaSubMetro = routeParamsToPropsMap.communityMarketAreaSubMetro,
      paramsMap = (0, _objectWithoutProperties3.default)(routeParamsToPropsMap, ['communityMarketArea', 'communityMarketAreaMetro', 'communityMarketAreaSubMetro']); // Ignore area on single load

  var _match$params = match.params,
      paramma = _match$params.communityMarketArea,
      parammam = _match$params.communityMarketAreaMetro,
      parammasm = _match$params.communityMarketAreaSubMetro,
      paramcn = _match$params.communityName,
      params = (0, _objectWithoutProperties3.default)(_match$params, ['communityMarketArea', 'communityMarketAreaMetro', 'communityMarketAreaSubMetro', 'communityName']); // Ignore area on single load

  return _fp2.default.getOr([], builderId + '.data', homes).reduce(function (result, item) {
    if (result === undefined && (_id !== undefined && item._id === _id || match && (0, _bdcoreNamedRoutes.paramsMatch)(params, paramsMap, item, true, state))) {
      return item;
    }

    return result;
  }, undefined);
};

exports.getHome = getHome;
var getHomeRouteProps = exports.getHomeRouteProps = function getHomeRouteProps(home, state) {
  return (0, _bdcoreNamedRoutes.getPropsFromItem)(home, routeParamsToPropsMap, true, state);
};

var getHomes = exports.getHomes = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, props, builderId) {
  return builderId;
}, function () {
  return _Filters.getFilterValues.apply(undefined, arguments);
}, function (_ref2, _ref3) {
  var _ref2$cloudData = _ref2.cloudData;
  _ref2$cloudData = _ref2$cloudData === undefined ? {} : _ref2$cloudData;
  var homes = _ref2$cloudData.homes;
  var _ref3$builderId = _ref3.builderId,
      builderId = _ref3$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref3$builderId;
  return _fp2.default.getOr([], builderId + '.data', homes);
}], function (state, builderId, filters, homes) {
  return (0, _Filters.processFilters)(state, 'homes', homes, filters, builderId);
});

exports.default = getHome;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/selectors.js
// module id = 227
// module chunks = 0